<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-12">
        <h3>Select Question Clipart</h3>
        <b-button
          type="is-info"
          size="is-small"
          @click="
            toggle_custom_layout_cl_drawer1 = !toggle_custom_layout_cl_drawer1
          "
          >Toggle Clipart Drawer
        </b-button>
        <clipart-selector
          v-if="toggle_custom_layout_cl_drawer1"
          @input="addClipartFromDrawer1"
        ></clipart-selector>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-12">
        <h3>Select Multi Cliparts</h3>
        <b-button
          type="is-info"
          size="is-small"
          @click="
            toggle_custom_layout_cl_drawer2 = !toggle_custom_layout_cl_drawer2
          "
          >Toggle Clipart Drawer
        </b-button>
        <clipart-selector
          v-if="toggle_custom_layout_cl_drawer2"
          @input="addClipartFromDrawer2"
        ></clipart-selector>
      </div>
    </div>
    <div class="up-input-group">
      <div>
        <up-numberinput
          size="xs"
          v-model="clipart_measurement.num_images"
          label="No. of Images"
          labelIcon="mdi mdi-alpha-n-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-switch
          v-model="clipart_measurement.drop_on_clipart"
          label="Is Drop on Clipart"
          labelIcon="mdi mdi-alpha-c-box-outline"
        ></up-switch>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <style-editor
          v-model="clipart_measurement.hollow_styles"
          title="drop area"
          show_height
          show_width
          show_x
          show_y
        ></style-editor>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <style-editor
          v-model="clipart_measurement.styles"
          show_height
          show_width
        ></style-editor>
      </div>
    </div>

    <show-clipart-measurement
      :clipart_measurement="clipart_measurement"
      @updated="clipartMeasurementUpdated"
      :isDragUser="true"
      show_border
    ></show-clipart-measurement>
  </div>
</template>

<script>
import ClipartSelector from "@/components/Question/Clipart/ClipartSelector";
import ShowClipartMeasurement from "./ShowClipartMeasurement.vue";
import { defaultClipartMeasurementValue } from "./utils";
import StyleEditor from "@/components/Common/StyleEditor/StyleEditor";

import UpSwitch from "@/components/UI/Inputs/UpSwitch";
import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";

export default {
  name: "set-clipart-measurement",
  props: {
    value: {
      type: Object,
    },
  },
  components: {
    ShowClipartMeasurement,
    ClipartSelector,
    StyleEditor,
    UpSwitch,
    UpNumberinput,
  },
  data() {
    return {
      clipart_measurement: this.value
        ? this.value
        : defaultClipartMeasurementValue(),
      toggle_custom_layout_cl_drawer1: false,
      toggle_custom_layout_cl_drawer2: false,
    };
  },
  methods: {
    clipartMeasurementUpdated(new_val) {
      console.log(new_val);
      this.clipart_measurement = new_val;
    },
    multiClipartPosition() {
      let num_images = this.clipart_measurement.num_images;
      this.clipart_measurement.properties = [];
      for (let j = 0; j < num_images; j++) {
        this.clipart_measurement.properties.push({
          x: 0,
          y: 0,
        });
      }
    },
    addClipartFromDrawer1(clipart_obj) {
      this.clipart_measurement.clipart = clipart_obj;
      this.$buefy.toast.open({
        message: "Added clipart to Clipart Measurement",
        type: "is-success",
      });
    },
    addClipartFromDrawer2(clipart_obj) {
      this.clipart_measurement.multi_clipart = clipart_obj;
      this.$buefy.toast.open({
        message: "Added clipart to Clipart Measurement",
        type: "is-success",
      });
    },
  },
  watch: {
    clipart_measurement: {
      handler: function(new_val) {
        this.$emit("input", new_val);
      },
      deep: true,
    },
    value: {
      handler: function(new_val) {
        this.clipart_measurement = new_val;
      },
      deep: true,
    },
    "clipart_measurement.num_images": {
      handler: function(new_val) {
        if (new_val != this.clipart_measurement.properties.length) {
          this.multiClipartPosition();
        }
      },
    },
  },
};
</script>

<style scoped></style>
